import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { BoostaBolt } from '@/components/BoostaBolt';

export default function MarketingNav() {
  const [open, setOpen] = React.useState(false);
  return (
    <nav className="fixed top-0 inset-x-0 z-50 px-4 md:px-8 py-4">
      <div className="max-w-7xl mx-auto glass rounded-2xl px-5 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <BoostaBolt size={30} animate/>
          <span className="font-display font-black text-xl tracking-tight text-3d">Boosta</span>
        </Link>
        <div className="hidden md:flex items-center gap-7 text-sm text-white/70">
          <a href="/#features" className="hover:text-white transition" data-testid="nav-features">Features</a>
          <a href="/#ai-engine" className="hover:text-white transition" data-testid="nav-ai-engine">AI Engine</a>
          <a href="/#workflow" className="hover:text-white transition" data-testid="nav-workflow">Workflow</a>
          <a href="/#pricing" className="hover:text-white transition" data-testid="nav-pricing">Pricing</a>
          <Link to="/blog" className="hover:text-white transition" data-testid="nav-blog">Blog</Link>
        </div>
        <div className="hidden md:flex items-center gap-3">
          <Link to="/login" className="text-sm text-white/80 hover:text-white transition px-3 py-2" data-testid="nav-signin">Sign in</Link>
          <Link to="/register" className="btn-primary text-sm px-4 py-2.5 rounded-full" data-testid="nav-get-started">
            Start free trial
          </Link>
        </div>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="w-6 h-6"/> : <Menu className="w-6 h-6"/>}
        </button>
      </div>
      {open && (
        <div className="md:hidden mt-2 max-w-7xl mx-auto glass rounded-2xl p-5 flex flex-col gap-4">
          <a href="/#features" className="text-white/80" onClick={()=>setOpen(false)}>Features</a>
          <a href="/#ai-engine" className="text-white/80" onClick={()=>setOpen(false)}>AI Engine</a>
          <a href="/#workflow" className="text-white/80" onClick={()=>setOpen(false)}>Workflow</a>
          <a href="/#pricing" className="text-white/80" onClick={()=>setOpen(false)}>Pricing</a>
          <Link to="/blog" className="text-white/80" onClick={()=>setOpen(false)}>Blog</Link>
          <Link to="/login" className="text-white/80">Sign in</Link>
          <Link to="/register" className="btn-primary text-sm px-4 py-2.5 rounded-full text-center">Start free trial</Link>
        </div>
      )}
    </nav>
  );
}
